/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationDto } from './ConversationDto';
import {
    ConversationDtoFromJSON,
    ConversationDtoFromJSONTyped,
    ConversationDtoToJSON,
    ConversationDtoToJSONTyped,
} from './ConversationDto';

/**
 * 
 * @export
 * @interface ConversationResponseDto
 */
export interface ConversationResponseDto {
    /**
     * Conversation details
     * @type {ConversationDto}
     * @memberof ConversationResponseDto
     */
    conversation: ConversationDto;
}

/**
 * Check if a given object implements the ConversationResponseDto interface.
 */
export function instanceOfConversationResponseDto(value: object): value is ConversationResponseDto {
    if (!('conversation' in value) || value['conversation'] === undefined) return false;
    return true;
}

export function ConversationResponseDtoFromJSON(json: any): ConversationResponseDto {
    return ConversationResponseDtoFromJSONTyped(json, false);
}

export function ConversationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'conversation': ConversationDtoFromJSON(json['conversation']),
    };
}

export function ConversationResponseDtoToJSON(json: any): ConversationResponseDto {
    return ConversationResponseDtoToJSONTyped(json, false);
}

export function ConversationResponseDtoToJSONTyped(value?: ConversationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversation': ConversationDtoToJSON(value['conversation']),
    };
}

